import { render } from "./ActionBtn.vue?vue&type=template&id=e3c2e70a"
import script from "./ActionBtn.vue?vue&type=script&lang=js"
export * from "./ActionBtn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aron/Herd/de-veense-veiling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__